var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageOkayOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 248,
    viewBox: "0 0 306 248",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1771 68.9999C35.1771 31.0304 69.274 0.25 111.335 0.25H229.379C271.439 0.25 305.536 31.0304 305.536 69V179C305.536 216.97 271.439 247.75 229.379 247.75H16.1378C10.5403 247.75 5.39376 244.978 2.73467 240.532C0.0755779 236.085 0.332396 230.681 3.4035 226.456L27.6854 193.054C32.5731 186.33 35.1771 178.464 35.1771 170.422V68.9999ZM111.335 27.75C86.0982 27.75 65.6401 46.2182 65.6401 68.9999V170.422C65.6401 183.825 61.3001 196.936 53.154 208.142L44.3519 220.25H229.379C254.615 220.25 275.073 201.782 275.073 179V69C275.073 46.2183 254.615 27.75 229.379 27.75H111.335ZM217.302 93.6523C223.25 99.022 223.25 107.728 217.302 113.098L171.607 154.348C165.659 159.717 156.015 159.717 150.067 154.348L127.219 133.723C121.271 128.353 121.271 119.647 127.219 114.277C133.168 108.908 142.812 108.908 148.76 114.277L160.837 125.18L195.761 93.6523C201.709 88.2826 211.354 88.2826 217.302 93.6523Z",
    fill: "#FF9900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageOkayOrange);
export default __webpack_public_path__ + "static/media/message-okay-orange.4c894c0f067fa607039c32149fd9df24.svg";
export { ForwardRef as ReactComponent };